import styled from 'styled-components';
import { WHITE, BLACK } from '../../../../../styles/variables.style';
import media from '../../../../../styles/media.style';

export const TextLabel = styled.div`
  font-size: 14px;
  margin-top: 15px;
`;

export const ToggleButton = styled.button`
  width: 130px;
  display: flex;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(155, 161, 165);
  background-color: ${({ isOpen }) => (isOpen ? 'rgba(152, 158, 162, 0.15)' : 'white')};
  padding: 12px 13px 11px 13px;
  margin: auto;
  outline: none;
  justify-content: space-around;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 25px;
  right: 15px;
  transform: translateY(-50%) rotate(45deg);
  display: inline-block;
  width: 25px;
  height: 25px;
  color: ${WHITE};
  background-color: transparent;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;
  ${media.tabletP`
    top: 27px;
  `};

  ::after {
    content: '';
    width: 15px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 15px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(${({ open }) => (open ? 0 : '90deg')});
  }
`;

export const ContentWrapper = styled.div`
  width: calc(100vw - 40px);
  max-width: 738px;
  padding-top: 45px;
  position: relative;
  background-color: rgb(238, 239, 240);
  box-shadow: inset 0px 4px 9px -0.75px rgba(0, 0, 0, 0.15);
  transform: translateX(-20px);
  margin-top: 20px;
  ${media.tabletP`
    width: 100vw;
    padding-top: 50px;
    transform: translateX(-76px);
  `};
`;

export const Wrapper = styled.div`
  width: 100%;
  text-align: center;
  margin: 28px auto;
`;

export const PlusIcon = styled.div`
  width: 1px;
  height: 12px;
  background: gray;
  display: inline-block;
  transform: translateY(1px);

  :before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    transform: rotate(90deg);
    background: gray;
  }
`;

export const MinusIcon = styled.div`
  width: 1px;
  height: 12px;
  background: gray;
  display: inline-block;
  transform: translateY(1px) rotate(90deg);
`;

export const ImageList = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 5px;
  flex-direction: row;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  ${media.tabletP`
    padding-bottom: 14px;
  `};
`;

export const Item = styled.div`
  padding: 10px 7.5px 10px 7.5px;
  text-align: center;
  ${media.tabletP`
    padding: 10px;
  `};

  :first-child {
    padding-left: 15px;
    ${media.tabletP`
      padding-left: 30px;
    `};
  }

  :last-child {
    padding-right: 15px;
    ${media.tabletP`
      padding-right: 30px;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/Common/ImageSlider/ImageSlider.style.js